import { render } from "./email-button.vue?vue&type=template&id=af679b20"
import script from "./email-button.vue?vue&type=script&lang=js"
export * from "./email-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__